import React from 'react';
import LegalPage from './LegalPage-new';

function SuggestionsPage(): React.ReactElement
{
    return (
        <LegalPage
            eyebrow="Suggestions"
            title="Share ideas for the next version of AcceliQA"
            summary="Feature requests, automation ideas, and integration suggestions help us build the workflows your team needs most."
            lastUpdated="April 8, 2026"
            sections={[
                {
                    id: 'feature-ideas',
                    title: 'Feature Ideas',
                    content: (
                        <>
                            <p>
                                Have an idea for a new capability or workflow improvement? Send it to{' '}
                                <a href="mailto:contact@accelirate.com?subject=AcceliQA%20Feature%20Suggestion">AcceliQADev@accelirate.com</a>{' '}
                                with the subject line “AcceliQA Feature Suggestion”.
                            </p>
                            <ul>
                                <li>New reporting or dashboard needs</li>
                                <li>Test-generation workflow enhancements</li>
                                <li>Role-based collaboration and review improvements</li>
                            </ul>
                        </>
                    )
                },
                {
                    id: 'workflow-and-integrations',
                    title: 'Workflow and Integration Suggestions',
                    content: (
                        <>
                            <p>
                                We are especially interested in ideas around Azure DevOps, CI/CD integration, traceability, approvals, and team collaboration. If a current step feels manual, let us know how you would like it automated.
                            </p>
                        </>
                    )
                },
                {
                    id: 'how-to-make-suggestions-actionable',
                    title: 'How to Make Suggestions Actionable',
                    content: (
                        <>
                            <p>
                                The most helpful suggestions explain the goal, the current pain point, and the expected outcome. If possible, include the role involved—QA lead, developer, product owner, or administrator—so we can understand the scenario clearly.
                            </p>
                        </>
                    )
                }
            ]}
            footerNote="We review suggestions continuously and use them to guide roadmap planning for usability, coverage visibility, and enterprise workflow automation."
        />
    );
}

export default SuggestionsPage;
